<template>
	<div>
		<v-card outlined elevation="0">
			<v-card-title>
				<span>Reserva de Laboratórios</span>
				<v-spacer></v-spacer>
	
				<AgendamentosAdmin v-if="$store.globalStore.getters.isAdmin" />

				<MeusAgendamentos v-if="$store.globalStore.getters.isAuth"/>
				
				<AgendamentosTodos/>

				
			</v-card-title>				
			<v-card-text>
				<v-divider></v-divider>
				<v-row>
					<v-col cols="12" md="6" lg="7">
						<Formulario :object="formulario" />	
					</v-col>

					<v-divider v-if="$vuetify.breakpoint.mdAndUp" vertical class="my-8"></v-divider>

					<v-col cols="12" md="6" lg="5" class="py-12">
						<v-divider v-if="$vuetify.breakpoint.smAndDown"></v-divider>
						<InstrucoesReserva />
					</v-col>
				</v-row>
			</v-card-text>				
		</v-card> 
	</div>
</template>

<script>
import Formulario from '@/components/reserva/form.vue'
import InstrucoesReserva from '@/components/InstrucoesReserva.vue'
import AgendamentosTodos from '@/components/AgendamentosTodos'
import MeusAgendamentos from '@/components/MeusAgendamentos.vue'
import AgendamentosAdmin from '@/components/AgendamentosAdmin.vue'

export default {
	name: 'Agenda',
	components: {
		Formulario, 
		InstrucoesReserva, AgendamentosTodos, MeusAgendamentos, AgendamentosAdmin
	},
	data:()=>{
		return{
			formulario:{
				solicitante: null,
				curso: null,
				disciplina: null,
                sala: null,
                finalidade: null,
                data: null,
                start:'10:00',
                end:'11:00',
				file_protocolo_pratica:null,
				file_reagentes_equipamentos:null,
				alunos: 0,
				titulo_aula: null,
				codturma: null,
				horario: null,
			}
		}
	},
	computed:{
		
	}
}
</script>
